import Vue from 'vue'

/* core layout */
Vue.component('app-header', require('./Header.vue').default)
Vue.component('app-footer', require('./Footer.vue').default)

/* wp templates */
Vue.component('app-index', require('./Index.vue').default)
Vue.component('app-single', require('./Single.vue').default)
Vue.component('app-single-longread', require('./SingleLongread.vue').default)
Vue.component('app-archive', require('./Archive.vue').default)
Vue.component('app-page', require('./Page.vue').default)
Vue.component('app-page-full-width', require('./PageFullWidth.vue').default)
Vue.component('app-page-who-we-are', require('./PageWhoWeAre.vue').default)

Vue.component('app-home', require('./Home.vue').default)
Vue.component('app-home-two', require('./HomeTwo.vue').default)
Vue.component('app-home-three', require('./HomeThree.vue').default)

Vue.component('single-post', require('./SinglePost.vue').default)
// Vue.component('category-post', require('./CategoryPost.vue').default)
Vue.component('video-post', require('./VideoPost.vue').default)
Vue.component('longread-post', require('./LongreadPost.vue').default)

Vue.component('archive-header', require('./ArchiveHeader.vue').default)
Vue.component('archive-pagination', require('./archive/Pagination.vue').default)
Vue.component('archive-post', require('./archive/Post.vue').default)

Vue.component('category-header', require('./category/Header.vue').default)
Vue.component('category-list', require('./category/List.vue').default)
Vue.component('category-post', require('./category/Post.vue').default)
Vue.component('category-featured-post', require('./category/FeaturedPost.vue').default)

Vue.component('author-header', require('./authors/Header.vue').default)
Vue.component('author-post', require('./authors/Post.vue').default)

Vue.component('tag-header', require('./tags/Header.vue').default)
Vue.component('search-header', require('./search/Header.vue').default)

Vue.component('media-card', require('./MediaCard.vue').default)


/* widgets */
Vue.component('email-widget', require('./widgets/Email.vue').default)
Vue.component('donate-widget', require('./widgets/Donate.vue').default)
Vue.component('highlights-widget', require('./widgets/Highlights.vue').default)
Vue.component('newslinks-widget', require('./widgets/Newslinks.vue').default)

/* ads */
Vue.component('ad-full-banner', require('./ads/FullBanner.vue').default)
Vue.component('ad-halfpage', require('./ads/Halfpage.vue').default)
Vue.component('ad-leaderboard', require('./ads/Leaderboard.vue').default)
Vue.component('ad-mid-leaderboard', require('./ads/MidLeaderboard.vue').default)
Vue.component('ad-mobile-banner', require('./ads/MobileBanner.vue').default)
Vue.component('ad-mobile-leaderboard', require('./ads/MobileLeaderboard.vue').default)
Vue.component('ad-mpu', require('./ads/MPU.vue').default)
Vue.component('ad-in-content', require('./ads/InContent.vue').default)